module.exports = __webpack_public_path__ + "img/tryakin.c4f38d18.jpg";